module.exports = __webpack_public_path__ + "static/TownOfLight4-f302be26fb86cb545a40bddcacd6d64f.png";